/**
 * Nombre humano de la frecuencia de cobro. Espejo de `frecuenciaLabel` en api-admin.
 * Antes las pantallas decían "quincenal" a mano porque el intervalo era fijo.
 */
export const frecuenciaLabel = (days: number | null | undefined, plural = false): string => {
    const d = Number(days);
    if (d === 1) return plural ? 'diarias' : 'diaria';
    if (d === 7) return plural ? 'semanales' : 'semanal';
    if (d === 15) return plural ? 'quincenales' : 'quincenal';
    if (d === 30) return plural ? 'mensuales' : 'mensual';
    return Number.isFinite(d) && d > 0 ? `cada ${d} días` : '';
};

/** Intervalo por defecto cuando la oferta no lo trae (créditos previos al cambio). */
export const DEFAULT_INTERVAL_DAYS = 15;

/** Monto máximo por nivel — debe coincidir con api/constants/creditos.constants.ts. */
export const LEVEL_AMOUNTS: Record<number, number> = {
    1: 500,
    2: 1000,
    3: 1500,
    4: 2000,
};

export const MAX_LEVEL = 4;

/**
 * Reparte `total` en `n` cuotas en céntimos enteros, con el residuo en la ÚLTIMA.
 * Espejo exacto de `splitAmount` (api-admin `installments.helper.ts` / api
 * `installments.util.ts`), que es lo que persiste el backend al activar: así la
 * calculadora de la oferta muestra al céntimo las mismas cuotas que firmará el comercio
 * (antes dividía en float y pintaba $183.33333…).
 */
export const splitAmountCents = (total: number, n: number): number[] => {
    const count = Number.isInteger(n) && n >= 1 ? n : 1;
    const totalCents = Math.round((Number(total) || 0) * 100);
    const base = Math.floor(totalCents / count);
    const out = Array.from({ length: count }, () => base);
    out[count - 1] += totalCents - base * count;
    return out;
};

export const splitAmount = (total: number, n: number): number[] => splitAmountCents(total, n).map(c => c / 100);

/**
 * Vencimientos tentativos: la cuota k vence `k × intervalDays` días después de `from`.
 * Mismo desplazamiento (`setDate`) que `installmentDueDate` del backend.
 */
export const installmentDueDates = (from: Date, n: number, intervalDays: number): Date[] => {
    const count = Number.isInteger(n) && n >= 1 ? n : 1;
    const step = Number.isInteger(intervalDays) && intervalDays >= 1 ? intervalDays : DEFAULT_INTERVAL_DAYS;
    return Array.from({ length: count }, (_, i) => {
        const d = new Date(from);
        d.setDate(d.getDate() + step * (i + 1));
        return d;
    });
};

export const MONTHS_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const MONTHS_ES_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
